export default __webpack_public_path__ + "static/media/teaching_speech.2317d22a.jpg";